import { Model } from '@appstrax/services/database';

export type KanbanCard = {
  id: string;
  ticketNumber?: number;
  title: string;
  description?: string;
  repoRole?: 'site' | 'api' | 'agent-api' | 'infra' | 'unknown';
  acceptanceCriteria?: string[];
  risk?: 'low' | 'med' | 'high';
  agentify?: {
    status?: 'completed' | 'failed';
    source?: 'auto' | 'manual';
    lastAttemptAt?: number;
    completedAt?: number;
    error?: string;
  };
  feedback?: Array<{
    source?: string;
    kind?: string;
    summary: string;
    at?: number;
  }>;
  pr?: {
    owner?: string;
    repo?: string;
    number?: number;
    url?: string;
    status?: string;
    reviewState?: string;
    lastComment?: string;
    updatedAt?: number;
    mergedAt?: number;
  };
};

export type KanbanColumn = {
  id: string;
  title: string;
  kind?: 'backlog' | 'execute' | 'review' | 'done' | 'custom';
  cards: KanbanCard[];
  widthPx?: number;
};

export class TicketsBoard extends Model {
  public projectId: string = '';
  public key: string = 'tickets.board';
  public columns: KanbanColumn[] = [];
  public version: number = 1;
}

